<!--组织结构-->
<template>
  <section class="combination">
    <el-input size="small" placeholder="请输入名称搜索" v-model="filterText"></el-input>
    <div class="combination-box">
      <el-tree
        class="filter-combination"
        :data="options"
        :props="defaultProps"
        show-checkbox
        node-key="id"
        :check-on-click-node="true"
        :expand-on-click-node="false"
        :filter-node-method="filterNode"
        :default-checked-keys="defaultChecked"
        @check="check"
        :check-strictly="isRadio"
        ref="combination"
      ></el-tree>
    </div>
  </section>
</template>

<script>
import { flatData } from "@/utils/flatData.js";
export default {
  name: "tide-combination",
  props: {
    isRadio: {
      type: Boolean,
      default: true
    },
    //双向绑定的值
    modelSelectIds: {
      type: Array,
      default: () => []
    },
    defaultChecked: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  model: {
    prop: "modelSelectIds",
    event: "export"
  },
  created() {
    //初始化。选中的和
  },
  data() {
    return {
      filterText: "",
      defaultProps: {
        children: "sub_organizationDto",
        label: "name"
      },
      selectIds: []
    };
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 共两个参数，依次为：传递给 data 属性的数组中该节点所对应的对象、树目前的选中状态对象，包含 checkedNodes、checkedKeys、halfCheckedNodes、halfCheckedKeys 四个属性.
    // 大致逻辑:单选时候，selectIds只放入选择的节点或者清空。多选时候，将选择的全部返回
    check(data, selects) {
      if (!this.isRadio) {
        this.selectIds = selects.checkedNodes.map(item => ({
          id: item.id,
          name: item.name
        }));
        this.$emit("export", this.selectIds);
      } else {
        // 先清空
        this.$refs.combination.setCheckedNodes([]);
        this.selectIds = [];
        if (selects.checkedKeys.includes(data.id)) {
          this.$refs.combination.setCheckedNodes([data]);
          this.selectIds.push({
            id: data.id,
            name: data.name
          });
        }
        this.$emit("export", this.selectIds);
      }
    },
    // 往外暴露一个根据id匹配名字的方法
    getMatchName(id) {
      console.log(id);
      if (id) {
        // console.log(this.options);
        let newArray = flatData(this.options);
        let result = "";
        newArray.forEach(item => {
          if (id === item.id) {
            result = item.name;
            return;
          }
        });
        return result;
      } else {
        return "";
      }
    },
    setCheckedNodes() {
      // 清空数据
      this.$refs.combination.setCheckedNodes([]);
    }
  },
  watch: {
    filterText(val) {
      this.$refs.combination.filter(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.combination {
  margin-top: 44px;
  .combination-box {
    border: 1px solid #eeeeee;
    // overflow-y: auto;
    // overflow: hidden;
    // overflow-y: scroll;
    margin: 12px 0;
    margin-bottom: 0;
    // margin-bottom: 50px;
  }
  .el-tree {
    // max-height: calc(100vh - 175px);
    // overflow-y:scroll;
  }
  // .el-tree-node__content {
  //   height: 40px;
  //   position: relative;
  //   &::after {
  //     content: "";
  //     display: block;
  //     width: 100%;
  //     height: 1px;
  //     background: #eeeeee;
  //     position: absolute;
  //     bottom: 0;
  //   }
  //   .el-tree-node__label {
  //     display: inline-block;
  //     width: calc(100% - 46px);
  //     line-height: 40px;
  //     text-align: left;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //     white-space: nowrap;
  //   }
  // }
}
</style>





// WEBPACK FOOTER //
// src/base/combination.vue